import { QueryEntity } from '@datorama/akita';
import {
  CostCenterOptionsState,
  getCostCenterOptionsStore,
  CostCenterOptionsStore,
} from './cost-center-options.store';
import { switchMap } from 'rxjs/operators';
import { CostCenterOption } from './cost-center-options.model';

const sortBy = (a: CostCenterOption, b: CostCenterOption) => (a.order ?? 0) - (b.order ?? 0);

export class CostCenterOptionsQuery extends QueryEntity<CostCenterOptionsState> {
  constructor(store: CostCenterOptionsStore) {
    super(store);
  }

  costCenterOptions = this.select(({ ui }) => ui).pipe(
    switchMap(({ corporateAccountId }) =>
      this.selectAll({
        filterBy: [x => !corporateAccountId || x.corporateAccountId === corporateAccountId],
        sortBy,
      })
    )
  );

  costCenterOptionsByAccount(corporateAccountId: string) {
    return this.selectAll({
      filterBy: [x => x.corporateAccountId === corporateAccountId],
      sortBy,
    });
  }

  isLoading = this.selectLoading();
}
// REPLACE the problematic line with this:
let _query: CostCenterOptionsQuery | undefined;
export function getCostCenterOptionsQuery(): CostCenterOptionsQuery {
  if (!_query) {
    _query = new CostCenterOptionsQuery(getCostCenterOptionsStore());
  }
  return _query;
}
